import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import useCountDown from '@hfe/max-use-countdown';
import './index.scss';
const CountDown = ({ endTime, suffix = '后到期', className = '' }) => {
    const now = Date.now();
    // 当时间已过期时，使用默认的 00:00:00
    let hours = 0, minutes = 0, seconds = 0;
    if (endTime >= now) {
        const countdownData = useCountDown(endTime, now);
        hours = countdownData.hours;
        minutes = countdownData.minutes;
        seconds = countdownData.seconds;
    }
    const formatTime = (time) => String(Math.max(0, time)).padStart(2, '0');
    return <View className={`count-down-wrapper ${className}`}>
      <Text className="count-down-time">
        {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
      </Text>
      <Text className="count-down-suffix">{suffix}</Text>
    </View>;
};
export default CountDown;
